console.log("Feature Dictionary Loaded");

const FEATURE_KEYWORDS = {

    night_vision: [
        "night vision",
        "night",
        "dark"
    ],

    human_detection: [
        "human detection",
        "person detection",
        "ai detection"
    ],

    wifi: [
        "wifi",
        "wi-fi",
        "wireless"
    ],

    four_g: [
        "4g",
        "sim",
        "sim card"
    ],

    two_way_audio: [
        "two way audio",
        "two-way audio",
        "talk",
        "microphone"
    ],

    solar: [
        "solar",
        "sun powered"
    ],

    waterproof: [
        "waterproof",
        "weatherproof"
    ],

    color_night_vision: [
        "color night vision",
        "full color night vision"
    ],

    sd_card: [
        "sd card",
        "memory card",
        "micro sd"
    ],

    ptz: [
        "ptz",
        "pan tilt zoom"
    ],

    motion_detection: [
        "motion detection",
        "motion sensor"
    ]

};